import { render } from "./CaptioningDashboard.vue?vue&type=template&id=1625dd7f"
import script from "./CaptioningDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptioningDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Captioning/CaptioningDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1625dd7f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1625dd7f', __exports__)) {
    api.reload('1625dd7f', __exports__)
  }
  
  module.hot.accept("./CaptioningDashboard.vue?vue&type=template&id=1625dd7f", () => {
    api.rerender('1625dd7f', render)
  })

}


export default __exports__